import { useAuth0 } from "@auth0/auth0-react";
import { Container } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { type ReactNode, useEffect } from "react";
import FullPageSpinner from "@/components/FullPageSpinner";

const Root = (): ReactNode => {
    const { isLoading, isAuthenticated } = useAuth0();
    const navigate = Route.useNavigate();

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (isAuthenticated) {
            // Only navigate after a second; this makes sure that we don't interrupt navigates from Auth0Provider
            const navigateTimeout = setTimeout(() => {
                navigate({ to: "/manage" });
            }, 1000);

            return () => {
                clearTimeout(navigateTimeout);
            };
        }

        if (import.meta.env.PROD) {
            window.location.href = "https://wingertlandservices.com/";
        }
    }, [isLoading, isAuthenticated, navigate]);

    if (isLoading || isAuthenticated) {
        return <FullPageSpinner />;
    }

    if (import.meta.env.DEV) {
        return (
            <Container>
                You are in development mode. In production this will redirect to the Wingert
                website.
            </Container>
        );
    }

    return null;
};

export const Route = createFileRoute("/")({
    component: Root,
});
